package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.FSRequestBuilder
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.addQueryParam
import com.fsryan.foundation.net.client.replacePathParams

class WMOccupationsRequestBuilder: FSRequestBuilder<WMOccupationsRequestBuilder, Nothing>() {

    override fun build(): FSRequest<Nothing> {
        method(FSRequest.Method.Get)
        replacePathParams("api", "v1", "occupations")
        removeQueryParams("format")
        addQueryParam(name = "format", value = "taxonomy")
        acceptJson()
        return super.build()
    }

    override fun self(): WMOccupationsRequestBuilder = this
}
